"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _StarterGrowthSuiteCard = _interopRequireDefault(require("./StarterGrowthSuiteCard"));

var RecommendedBundlesSection = function RecommendedBundlesSection() {
  return _react.default.createElement("div", {
    className: "text-center m-top-10"
  }, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "recommendedBundles.title"
  })), _react.default.createElement(_StarterGrowthSuiteCard.default, null));
};

var _default = RecommendedBundlesSection;
exports.default = _default;
module.exports = exports.default;